import { takeEvery, select, call, put } from 'redux-saga/effects';
import ocularisService from '../../services/ocularis/ocularisService';
import { openWarningException } from "../layouts/actions";


function* ptzSaga(action) {
  const {token} = yield select(state => state.API);
  const {ptzCapibilities} = yield select(state => state.cameras);
  const {pane, coords} = action;
  const {right, top} = coords;

  const capability = ptzCapibilities[pane];

  try {

    if (right && top) {
      (capability.has_ptz && capability.has_ptz_box)
        ? yield call(() => ocularisService.ptzBox({token, pane, coordintates: coords}))
        : yield put(openWarningException("Camera doesn't support ptz-box. Use digital zoom or buttons zoom-in, zoom-out"))
    } else {
      yield call(() => ocularisService.ptzClick({token, pane, coordintates: coords}))
    }

  } catch (e) {

  }
}

function* zoomIn(action) {
  const {token} = yield select(state => state.API);
  const {pane} = action;

  try {
    yield call(() => ocularisService.zoomIn(token, pane))
  } catch (e) {

  }
}

function* zoomOut(action) {
  const {token} = yield select(state => state.API);
  const {pane} = action;

  try {
    yield call(() => ocularisService.zoomOut(token, pane))
  } catch (e) {

  }
}

function* triggerPTZSaga(action) {
  const {token} = yield select(state => state.API);
  const {currentCameras} = yield select(state => state.cameras);
  const {pane, triggerId} = action;

  try {
    yield call(() => ocularisService.triggerPTZ({token, triggerId, cameraId: currentCameras[pane].id, pane}))
  } catch (e) {

  }
}

function* gotoPreset(action) {
  const {token} = yield select(state => state.API);
  const {pane, presetId} = action;

  try {
    yield call(() => ocularisService.gotoPreset(token, pane, presetId))
  } catch (e) {

  }
}


export default function* () {
  yield takeEvery('doPTZaction', ptzSaga);
  yield takeEvery('ptzZoomIn', zoomIn);
  yield takeEvery('ptzZoomOut', zoomOut);
  yield takeEvery('ptzTrigger', triggerPTZSaga);
  yield takeEvery('gotoPreset', gotoPreset);
}